export default data => `
<div class="google-info-window">
    <div class="google-info-window__close">
      <i class="icon-close icon-close--black"></i>
    </div>
  <h6 class="google-info-window__title body-copy-black">${data.name}</h6>
  ${data.transport && data.transport.length > 0
    ? `<div class="google-info-window__transport-item">
          <div class="google-info-window__transport-item-inner">
            <i class="transport-icon-${data.transport[0].type}"></i>
            <span class="google-info-window__transport-name">${data.transport[0].name}</span>
          </div>
          ${data.transport[0].walking
      ? `
          <div class="google-info-window__transport-item-inner">
            <i class="icon-walking icon-walking-black"></i>
            <span class="google-info-window__transport-walking-time">${data.transport[0].walking}</span>
          </div>`
      : ''
    }
        </div>`
    : ''
  }
  <p class="google-info-window__text body-copy-light">
    <a href="${data.link}" class="d-none">View Details</a>
    <a target="_blank" href="${data.directions}">View Directions</a>
  </p>
</div>`;
